import { EntityType } from '../../enums/entityType';
import type { BuiltinIntegrationSpec } from '../../interfaces/integrationSpec';
import { IntegrationCategory } from '../../interfaces/integrationSpec';

import airbyteSvg from '../../public/images/logos/integrations/airbyte.svg';
import airflowSvg from '../../public/images/logos/integrations/airflow.svg';
import amplitudeSvg from '../../public/images/logos/integrations/amplitude.svg';
import bigquerySvg from '../../public/images/logos/integrations/bigquery.svg';
import censusSvg from '../../public/images/logos/integrations/census.svg';
import clickhouseSvg from '../../public/images/logos/integrations/clickhouse.svg';
import cluvioSvg from '../../public/images/logos/integrations/cluvio.svg';
import coalesceSvg from '../../public/images/logos/integrations/coalesce.svg';
import confluenceSvg from '../../public/images/logos/integrations/confluence.svg';
import confluentKafkaSvg from '../../public/images/logos/integrations/confluent_kafka.svg';
import cosmosSvg from '../../public/images/logos/integrations/cosmos.svg';
import customSvg from '../../public/images/logos/integrations/custom.svg';
import cyeraSvg from '../../public/images/logos/integrations/cyera.svg';
import dagsterSvg from '../../public/images/logos/integrations/dagster.svg';
import databricksSvg from '../../public/images/logos/integrations/databricks.svg';
import datafactorySvg from '../../public/images/logos/integrations/datafactory.svg';
import dataformSvg from '../../public/images/logos/integrations/dataform.svg';
import datalakeSvg from '../../public/images/logos/integrations/datalake.svg';
import dataplexSvg from '../../public/images/logos/integrations/dataplex.svg';
import dbtSvg from '../../public/images/logos/integrations/dbt.svg';
import druidSvg from '../../public/images/logos/integrations/druid.svg';
import dynamodbSvg from '../../public/images/logos/integrations/dynamodb.svg';
import fivetranSvg from '../../public/images/logos/integrations/fivetran.svg';
import gcsSvg from '../../public/images/logos/integrations/gcs.svg';
import googleDriveSvg from '../../public/images/logos/integrations/gdrive.svg';
import gitSvg from '../../public/images/logos/integrations/git.svg';
import githubSvg from '../../public/images/logos/integrations/github.svg';
import gleanSvg from '../../public/images/logos/integrations/glean.svg';
import glueSvg from '../../public/images/logos/integrations/glue.svg';
import gmailSvg from '../../public/images/logos/integrations/gmail.svg';
import greatExpectationsSvg from '../../public/images/logos/integrations/great_expectations.svg';
import hashboardSvg from '../../public/images/logos/integrations/hashboard.svg';
import hexSvg from '../../public/images/logos/integrations/hex.svg';
import hightouchSvg from '../../public/images/logos/integrations/hightouch.svg';
import hiveSvg from '../../public/images/logos/integrations/hive.svg';
import informaticaSvg from '../../public/images/logos/integrations/informatica.svg';
import jiraSvg from '../../public/images/logos/integrations/jira.svg';
import kafkaSvg from '../../public/images/logos/integrations/kafka.svg';
import lightdashSvg from '../../public/images/logos/integrations/lightdash.svg';
import linearSvg from '../../public/images/logos/integrations/linear.svg';
import lookerSvg from '../../public/images/logos/integrations/looker.svg';
import lookerStudioSvg from '../../public/images/logos/integrations/looker_studio.svg';
import matillionSvg from '../../public/images/logos/integrations/matillion.svg';
import metabaseSvg from '../../public/images/logos/integrations/metabase.svg';
import microStrategySvg from '../../public/images/logos/integrations/microStrategy.svg';
import mixpanelSvg from '../../public/images/logos/integrations/mixpanel.svg';
import modeSvg from '../../public/images/logos/integrations/mode.svg';
import mongodbSvg from '../../public/images/logos/integrations/mongodb.svg';
import monteCarloSvg from '../../public/images/logos/integrations/monte_carlo.svg';
import motherduckSvg from '../../public/images/logos/integrations/motherduck.svg';
import msTeamsSvg from '../../public/images/logos/integrations/ms_teams.svg';
import mysqlSvg from '../../public/images/logos/integrations/mysql.svg';
import omniSvg from '../../public/images/logos/integrations/omni.svg';
import oracleSvg from '../../public/images/logos/integrations/oracle.svg';
import pagerdutySvg from '../../public/images/logos/integrations/pagerduty.svg';
import polytomicSvg from '../../public/images/logos/integrations/polytomic.svg';
import postgresSvg from '../../public/images/logos/integrations/postgres.svg';
import powerbiSvg from '../../public/images/logos/integrations/powerbi.svg';
import presetSvg from '../../public/images/logos/integrations/preset.svg';
import quicksightSvg from '../../public/images/logos/integrations/quicksight.svg';
import redashSvg from '../../public/images/logos/integrations/redash.svg';
import redshiftSvg from '../../public/images/logos/integrations/redshift.svg';
import retoolSvg from '../../public/images/logos/integrations/retool.svg';
import s3Svg from '../../public/images/logos/integrations/s3.svg';
import salesforceSvg from '../../public/images/logos/integrations/salesforce.svg';
import servicenowSvg from '../../public/images/logos/integrations/servicenow.svg';
import sigmaDarkSvg from '../../public/images/logos/integrations/sigma-dark.svg';
import sigmaSvg from '../../public/images/logos/integrations/sigma.svg';
import singlestoreSvg from '../../public/images/logos/integrations/singlestore.svg';
import slackSvg from '../../public/images/logos/integrations/slack.svg';
import snowflakeSvg from '../../public/images/logos/integrations/snowflake.svg';
import sodaSvg from '../../public/images/logos/integrations/soda.svg';
import sqlserverSvg from '../../public/images/logos/integrations/sqlserver.svg';
import starburstSvg from '../../public/images/logos/integrations/starburst.svg';
import stitchSvg from '../../public/images/logos/integrations/stitch.svg';
import supersetSvg from '../../public/images/logos/integrations/superset.svg';
import synapseSvg from '../../public/images/logos/integrations/synapse.svg';
import tableauSvg from '../../public/images/logos/integrations/tableau.svg';
import thoughtspotSvg from '../../public/images/logos/integrations/thoughtspot.svg';
import trinoSvg from '../../public/images/logos/integrations/trino.svg';
import {
	DOCS_EXTENSION_BASE,
	DOCS_INTEGRATION_BASE,
} from './integrations.constants';
export const integrationList: BuiltinIntegrationSpec[] = [
	{
		name: 'Snowflake',
		type: 'snowflake',
		group: 'Data warehouses',
		description:
			'Connect Secoda to Snowflake to enable simple data discovery across all of your data.',
		src: snowflakeSvg,
		helpArticle: `${DOCS_INTEGRATION_BASE}data-warehouses/snowflake-integration`,
		documentationMarkdown:
			'https://docs.secoda.com/integrations/data-warehouses/snowflake-integration.md',
		categories: [IntegrationCategory.WAREHOUSE],
		resource_type: EntityType.table,
		entity_type: EntityType.table,
		supportsQueryBlocks: true,
		supportsPreviews: false,
		supportsSchemaConfiguration: true,
		supportGoogleIdentityAwareProxy: false,
		supportsChartsTab: false,
		supportsPushMetadata: true,
		testable: true,
		supportsDataAccessRequests: true,
		supportsDataAccessRequestPreferences: [
			'create_temporary_user_and_role',
			'create_and_grant_temporary_role',
			'grant_privileges_to_user_direct',
			'grant_privileges_to_role',
			'manual',
		],
		suggestWhitelist: true,
		secodaEnabled: true,
		supportsUserLevelCredentials: true,
		userLevelCredentialsFields: [
			'user',
			'password',
			'private_key',
			'passphrase',
		],
	},
	{
		name: 'BigQuery',
		type: 'bigquery',
		group: 'Data warehouses',
		description:
			'Connect BigQuery to Secoda to find your tables and metadata easily. You can use Secoda to understand how BigQuery tables connect to the rest of your data stack.',
		src: bigquerySvg,
		helpArticle: `${DOCS_INTEGRATION_BASE}data-warehouses/bigquery-integration`,
		documentationMarkdown:
			'https://docs.secoda.com/integrations/data-warehouses/bigquery-integration.md',
		categories: [IntegrationCategory.WAREHOUSE],
		entity_type: EntityType.table,
		resource_type: EntityType.table,
		supportsPreviews: true,
		supportsQueryBlocks: true,
		supportsPushMetadata: true,
		supportsSchemaConfiguration: true,
		supportsDataAccessRequests: true,
		supportsDataAccessRequestPreferences: ['manual'],
		supportGoogleIdentityAwareProxy: false,
		supportsChartsTab: true,
		testable: true,
		groupSettings: {
			OAuth: {
				isOAuth: true,
				testable: false,
			},
			Credentials: {
				testable: true,
			},
		},
		suggestWhitelist: true,
		secodaEnabled: true,
		supportsUserLevelCredentials: true,
		userLevelCredentialsFields: ['credentials'],
	},
	{
		name: 'Google Drive',
		type: 'gdrive',
		group: 'Productivity',
		description:
			'Connect your Google Drive to Secoda to find your files and folders easily.',
		src: googleDriveSvg,
		helpArticle: `${DOCS_EXTENSION_BASE}google-drive`,
		documentationMarkdown: 'https://docs.secoda.com/extensions/google-drive.md',
		categories: [IntegrationCategory.COMMUNICATION],
		secodaEnabled: false,
		testable: true,
		supportsSchemaConfiguration: true,
		supportsChartsTab: true,
		supportsPreviews: false,
		supportsQueryBlocks: false,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: false,
		groupSettings: {
			OAuth: {
				isOAuth: true,
				testable: true,
			},
		},
	},
	{
		name: 'Dataplex',
		type: 'dataplex',
		group: 'Data quality',
		description:
			'Connect Dataplex to Secoda to sync your tag templates and catalog metadata.',
		src: dataplexSvg,
		helpArticle: `${DOCS_INTEGRATION_BASE}data-quality-tools/dataplex`,
		documentationMarkdown:
			'https://docs.secoda.com/integrations/data-quality-tools/dataplex.md',
		categories: [IntegrationCategory.TEST],
		testable: true,
		supportsPreviews: false,
		supportsQueryBlocks: false,
		supportsSchemaConfiguration: false,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: false,
		supportsChartsTab: true,
		suggestWhitelist: false,
		secodaEnabled: true,
		secodaCoreEnabled: true,
	},
	{
		name: 'Postgres',
		type: 'postgres',
		group: 'Databases',
		description:
			'Connect Postgres to Secoda to find your queries and tables easily. You can use Secoda to understand how Postgres connects to the rest of your data stack.',
		src: postgresSvg,
		helpArticle: `${DOCS_INTEGRATION_BASE}databases/postgres-integration`,
		documentationMarkdown:
			'https://docs.secoda.com/integrations/databases/postgres-integration.md',

		categories: [IntegrationCategory.DATABASE],
		entity_type: EntityType.table,
		resource_type: EntityType.table,
		supportsPreviews: true,
		supportsQueryBlocks: true,
		supportsSchemaConfiguration: true,
		supportsPushMetadata: true,
		supportsChartsTab: true,
		testable: true,
		supportsDataAccessRequests: true,
		supportsDataAccessRequestPreferences: [
			'create_temporary_user_and_role',
			'create_and_grant_temporary_role',
			'grant_privileges_to_user_direct',
			'grant_privileges_to_role',
			'manual',
		],
		supportGoogleIdentityAwareProxy: false,
		suggestWhitelist: true,
		secodaEnabled: true,
		supportsUserLevelCredentials: true,
		userLevelCredentialsFields: ['user', 'password'],
	},
	{
		name: 'Redshift',
		type: 'redshift',
		group: 'Data warehouses',
		description:
			'Connect Redshift to Secoda to find your tables and metadata easily. You can use Secoda to understand how Redshift tables connect to the rest of your data stack.',
		src: redshiftSvg,
		helpArticle: `${DOCS_INTEGRATION_BASE}data-warehouses/redshift-integration`,
		documentationMarkdown:
			'https://docs.secoda.com/integrations/data-warehouses/redshift-integration.md',
		categories: [IntegrationCategory.WAREHOUSE],
		entity_type: EntityType.table,
		resource_type: EntityType.table,
		supportsPreviews: true,
		supportsQueryBlocks: true,
		supportsSchemaConfiguration: true,
		supportsPushMetadata: true,
		supportsDataAccessRequests: true,
		supportsChartsTab: true,
		supportsDataAccessRequestPreferences: [
			'create_temporary_user_and_role',
			'create_and_grant_temporary_role',
			'grant_privileges_to_user_direct',
			'grant_privileges_to_role',
			'manual',
		],
		supportGoogleIdentityAwareProxy: false,
		testable: true,
		suggestWhitelist: true,
		secodaEnabled: true,
	},
	{
		name: 'MySQL',
		type: 'mysql',
		group: 'Databases',
		description:
			'Connect MySQL to Secoda to find your queries and tables easily. You can use Secoda to understand how MySQL connects to the rest of your data stack.',
		src: mysqlSvg,
		helpArticle: `${DOCS_INTEGRATION_BASE}databases/mysql-integration`,
		documentationMarkdown:
			'https://docs.secoda.com/integrations/databases/mysql-integration.md',
		categories: [IntegrationCategory.DATABASE],
		entity_type: EntityType.table,
		resource_type: EntityType.table,
		supportsPreviews: true,
		supportsQueryBlocks: true,
		supportsSchemaConfiguration: true,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: false,
		supportsChartsTab: true,
		testable: true,
		suggestWhitelist: true,
		secodaEnabled: true,
	},
	{
		name: 'Microsoft SQL Server',
		type: 'mssql',
		group: 'Databases',
		description:
			'Use Secoda to understand how Microsoft SQL Server tables connect to the rest of your data stack.',
		src: sqlserverSvg,
		helpArticle: `${DOCS_INTEGRATION_BASE}databases/microsoft-sql-server`,
		documentationMarkdown:
			'https://docs.secoda.com/integrations/databases/microsoft-sql-server.md',
		categories: [IntegrationCategory.DATABASE],
		entity_type: EntityType.table,
		resource_type: EntityType.table,
		supportsPreviews: true,
		supportsQueryBlocks: true,
		supportsSchemaConfiguration: true,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: false,
		supportsChartsTab: true,
		testable: true,
		suggestWhitelist: true,
		secodaEnabled: true,
	},
	{
		name: 'Oracle',
		type: 'oracle',
		group: 'Databases',
		description:
			'Connect Oracle to Secoda to easily search for all your information in Secoda.',
		src: oracleSvg,
		helpArticle: `${DOCS_INTEGRATION_BASE}databases/oracle-integration`,
		documentationMarkdown:
			'https://docs.secoda.com/integrations/databases/oracle-integration.md',
		categories: [IntegrationCategory.DATABASE],
		entity_type: EntityType.table,
		resource_type: EntityType.table,
		supportsPreviews: true,
		supportsQueryBlocks: true,
		supportsSchemaConfiguration: true,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: false,
		supportsChartsTab: true,
		testable: true,
		suggestWhitelist: true,
		secodaEnabled: true,
	},
	{
		name: 'MotherDuck',
		type: 'motherduck',
		group: 'Databases',
		description:
			'Connect MotherDuck to Secoda to easily search for all your tables and columns in Secoda.',
		src: motherduckSvg,
		helpArticle: `${DOCS_INTEGRATION_BASE}data-warehouses/motherduck`,
		documentationMarkdown:
			'https://docs.secoda.com/integrations/data-warehouses/motherduck.md',
		categories: [IntegrationCategory.DATABASE],
		entity_type: EntityType.table,
		resource_type: EntityType.table,
		supportsPreviews: true,
		supportsQueryBlocks: true,
		supportsSchemaConfiguration: true,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: false,
		supportsChartsTab: true,
		testable: true,
		suggestWhitelist: true,
		secodaEnabled: true,
	},
	{
		name: 'Glue',
		type: 'glue',
		group: 'Data pipeline',
		description:
			'Connect Glue to Secoda to easily search for all your Glue information in Secoda.',
		src: glueSvg,
		helpArticle: `${DOCS_INTEGRATION_BASE}data-pipeline-tools/aws-glue-integration`,
		documentationMarkdown:
			'https://docs.secoda.com/integrations/data-pipeline-tools/aws-glue-integration.md',
		categories: [IntegrationCategory.DATABASE],
		entity_type: EntityType.table,
		resource_type: EntityType.table,
		supportsPreviews: true,
		supportsQueryBlocks: true,
		supportsSchemaConfiguration: false,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: false,
		supportsChartsTab: true,
		testable: true,
		suggestWhitelist: false,
		secodaEnabled: true,
		secodaCoreEnabled: true,
	},
	{
		name: 'Trino',
		type: 'trino',
		group: 'Databases',
		description:
			'Connect Trino to Secoda to find your queries and tables easily. You can use Secoda to understand how Trino connects to the rest of your data stack.',
		src: trinoSvg,
		helpArticle: `${DOCS_INTEGRATION_BASE}query-engines/trino`,
		documentationMarkdown:
			'https://docs.secoda.com/integrations/query-engines/trino.md',
		categories: [IntegrationCategory.DATABASE],
		entity_type: EntityType.table,
		resource_type: EntityType.table,
		isBeta: true,
		supportsPreviews: true,
		supportsQueryBlocks: true,
		supportsSchemaConfiguration: true,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: false,
		supportsChartsTab: true,
		testable: true,
		suggestWhitelist: true,
		secodaEnabled: true,
		secodaCoreEnabled: true,
	},
	{
		name: 'Tableau',
		type: 'tableau',
		group: 'Data visualization',
		description:
			'Connect Tableau to Secoda to sync your workbooks, dashboards, sheets, and data sources.',
		src: tableauSvg,
		helpArticle: `${DOCS_INTEGRATION_BASE}data-visualization-tools/tableau-integration`,
		documentationMarkdown:
			'https://docs.secoda.com/integrations/data-visualization-tools/tableau-integration.md',
		categories: [IntegrationCategory.DASHBOARD],
		entity_type: EntityType.dashboard,
		resource_type: EntityType.dashboard,
		supportsPreviews: true,
		supportsQueryBlocks: false,
		supportsSchemaConfiguration: false,
		supportsDataAccessRequests: true,
		supportsDataAccessRequestPreferences: ['manual'],
		supportGoogleIdentityAwareProxy: false,
		supportsChartsTab: true,
		testable: true,
		supportsPushMetadata: true,
		suggestWhitelist: true,
		secodaEnabled: true,
		secodaCoreEnabled: true,
	},
	{
		name: 'Looker',
		type: 'looker',
		group: 'Data visualization',
		description:
			'Easily search for all your Looker information in Secoda. The Looker integration will pull information related to Looks and put them into their own page on the Secoda UI.',
		src: lookerSvg,
		helpArticle: `${DOCS_INTEGRATION_BASE}data-visualization-tools/looker-integration`,
		documentationMarkdown:
			'https://docs.secoda.com/integrations/data-visualization-tools/looker-integration.md',
		encrypted_fields: ['client_id', 'client_secret'],
		categories: [IntegrationCategory.DASHBOARD],
		entity_type: EntityType.dashboard,
		resource_type: EntityType.dashboard,
		supportsPreviews: true,
		supportsQueryBlocks: false,
		supportsSchemaConfiguration: false,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: false,
		supportsChartsTab: true,
		testable: true,
		suggestWhitelist: true,
		secodaEnabled: true,
		secodaCoreEnabled: true,
	},
	{
		name: 'Power BI',
		type: 'powerbi',
		group: 'Data visualization',
		description:
			'The Power BI integration will pull information related to your reports and put them into their own page on the Secoda UI.',
		src: powerbiSvg,
		helpArticle: `${DOCS_INTEGRATION_BASE}data-visualization-tools/power-bi`,
		documentationMarkdown:
			'https://docs.secoda.com/integrations/data-visualization-tools/power-bi.md',
		groupSettings: {
			OAuth: {
				isOAuth: true,
				testable: false,
			},
			Managed: {
				testable: true,
			},
		},
		categories: [IntegrationCategory.DASHBOARD],
		entity_type: EntityType.dashboard,
		resource_type: EntityType.dashboard,
		testable: false,
		supportsPreviews: true,
		supportsQueryBlocks: false,
		supportsSchemaConfiguration: false,
		suggestWhitelist: false,
		supportsDataAccessRequests: true,
		supportsDataAccessRequestPreferences: ['manual'],
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: false,
		supportsChartsTab: true,
		secodaEnabled: true,
		secodaCoreEnabled: true,
	},
	{
		name: 'QuickSight',
		type: 'quicksight',
		group: 'Data visualization',
		description:
			'Connect Quicksight to Secoda to easily search for all your dashboards information in Secoda.',
		src: quicksightSvg,
		helpArticle: `${DOCS_INTEGRATION_BASE}data-visualization-tools/quicksight-integration`,
		documentationMarkdown:
			'https://docs.secoda.com/integrations/data-visualization-tools/quicksight-integration.md',
		categories: [IntegrationCategory.DASHBOARD],
		entity_type: EntityType.table,
		resource_type: EntityType.table,
		supportsPreviews: true,
		supportsQueryBlocks: false,
		supportsSchemaConfiguration: false,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: false,
		supportsChartsTab: true,
		testable: true,
		suggestWhitelist: false,
		secodaEnabled: true,
		secodaCoreEnabled: true,
	},
	{
		name: 'Databricks',
		type: 'databricks',
		group: 'Data warehouses',
		description:
			'Connect Secoda to Databricks to enable simple data discovery across all of your data.',
		supportsPreviews: true,
		src: databricksSvg,
		helpArticle: `${DOCS_INTEGRATION_BASE}data-warehouses/databricks-integration`,
		documentationMarkdown:
			'https://docs.secoda.com/integrations/data-warehouses/databricks-integration.md',

		categories: [IntegrationCategory.DATABASE],
		entity_type: EntityType.table,
		resource_type: EntityType.table,
		supportsQueryBlocks: true,
		supportsSchemaConfiguration: true,
		supportsDataAccessRequests: true,
		supportsDataAccessRequestPreferences: ['manual'],
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: false,
		supportsChartsTab: true,
		testable: true,
		suggestWhitelist: true,
		secodaEnabled: true,
		userLevelCredentialsFields: ['access_token'],
		supportsUserLevelCredentials: true,
		supportsOAuthForUserCredentials: true,
	},
	{
		name: 'Apache Hive',
		type: 'hive',
		group: 'Data warehouses',
		description:
			'Connect Secoda to Hive to find your tables and metadata easily. You can use Secoda to understand how Hive tables connect to the rest of your data stack.',
		supportsPreviews: true,
		src: hiveSvg,
		helpArticle: `${DOCS_INTEGRATION_BASE}data-warehouses/apache-hive`,
		documentationMarkdown:
			'https://docs.secoda.com/integrations/data-warehouses/apache-hive.md',

		categories: [IntegrationCategory.DATABASE],
		entity_type: EntityType.table,
		resource_type: EntityType.table,
		isBeta: true,
		supportsQueryBlocks: true,
		supportsSchemaConfiguration: true,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: false,
		supportsChartsTab: true,
		testable: true,
		suggestWhitelist: true,
		secodaEnabled: true,
		secodaCoreEnabled: true,
	},
	{
		name: 'Mode',
		type: 'mode',
		group: 'Data visualization',
		description:
			'Search Secoda for your Mode reports. We make it easy to automatically capture data from Mode, including reports, users and more.',
		src: modeSvg,
		helpArticle: `${DOCS_INTEGRATION_BASE}data-visualization-tools/mode`,
		documentationMarkdown:
			'https://docs.secoda.com/integrations/data-visualization-tools/mode.md',
		categories: [IntegrationCategory.DASHBOARD],
		entity_type: EntityType.dashboard,
		resource_type: EntityType.dashboard,
		supportsPreviews: true,
		supportsQueryBlocks: false,
		supportsSchemaConfiguration: false,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: false,
		supportsChartsTab: true,
		testable: true,
		suggestWhitelist: false,
		secodaEnabled: true,
		secodaCoreEnabled: true,
	},
	{
		name: 'Omni',
		type: 'omni',
		group: 'Data visualization',
		description:
			'Connect Omni Analytics to Secoda to catalog your folders, models, queries, dashboards, and documents. The Omni integration will pull all your analytics assets into Secoda, making them searchable and adding context.',
		src: omniSvg,
		helpArticle: `${DOCS_INTEGRATION_BASE}data-visualization-tools/omni`,
		documentationMarkdown:
			'https://docs.secoda.com/integrations/data-visualization-tools/omni.md',
		encrypted_fields: ['api_key'],
		categories: [IntegrationCategory.DASHBOARD],
		entity_type: EntityType.dashboard,
		resource_type: EntityType.dashboard,
		testable: true,
		secodaEnabled: true,
		supportsPreviews: true,
		supportsQueryBlocks: false,
		supportsSchemaConfiguration: false,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: false,
		supportsChartsTab: true,
		secodaCoreEnabled: true,
	},
	{
		name: 'Redash',
		type: 'redash',
		group: 'Data visualization',
		description:
			'Connect Redash to Secoda to find your queries, dashboards and visualizations easily. You can use Secoda to understand how Redash connects to the rest of your data stack.',
		src: redashSvg,
		helpArticle: `${DOCS_INTEGRATION_BASE}data-visualization-tools/redash`,
		documentationMarkdown:
			'https://docs.secoda.com/integrations/data-visualization-tools/redash.md',
		categories: [IntegrationCategory.DASHBOARD],
		entity_type: EntityType.dashboard,
		resource_type: EntityType.dashboard,
		testable: true,
		suggestWhitelist: false,
		secodaEnabled: true,
		supportsChartsTab: true,
		supportsQueryBlocks: false,
		supportsSchemaConfiguration: false,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: false,
		supportsPreviews: false,
		secodaCoreEnabled: true,
	},
	{
		name: 'Slack',
		type: 'slack',
		group: 'Productivity',
		description:
			'Connect Slack to Secoda to get notified on schema changes, outdated tables, and documentation changes.',
		src: slackSvg,
		// Can't use the base help article because it's a different format
		helpArticle: `${DOCS_EXTENSION_BASE}slack-connection`,
		documentationMarkdown:
			'https://docs.secoda.com/extensions/slack-connection.md',
		oauth: {
			base_url: 'https://sp.secoda.co/initiate',
			redirect_uri: 'https://sp.secoda.co/callback',
			response_type: 'code',
		},
		categories: [IntegrationCategory.COMMUNICATION],
		testable: false,
		suggestWhitelist: false,
		supportsPreviews: false,
		supportsQueryBlocks: false,
		supportsSchemaConfiguration: false,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: false,
		supportsChartsTab: true,
		secodaEnabled: true,
		isExtension: true,
	},
	{
		name: 'Microsoft Teams',
		type: 'ms_teams',
		type_label: 'Microsoft Teams',
		group: 'Productivity',
		description:
			'Connect Microsoft Teams to Secoda to get notified on schema changes, outdated tables, and documentation changes.',
		src: msTeamsSvg,
		helpArticle: `${DOCS_EXTENSION_BASE}microsoft-teams`,
		documentationMarkdown:
			'https://docs.secoda.com/extensions/microsoft-teams.md',
		categories: [IntegrationCategory.COMMUNICATION],
		testable: true,
		suggestWhitelist: false,
		supportsPreviews: false,
		supportsQueryBlocks: false,
		supportsSchemaConfiguration: false,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: false,
		supportsChartsTab: true,
		secodaEnabled: true,
		isExtension: true,
		secodaCoreEnabled: true,
	},
	{
		name: 'GitHub',
		type: 'github',
		group: 'Productivity',
		description:
			'Connect GitHub to Secoda to get notified of changes to your dbt models and data pipelines.',
		src: githubSvg,
		helpArticle: `${DOCS_EXTENSION_BASE}github`,
		documentationMarkdown: 'https://docs.secoda.com/extensions/github.md',
		oauth: {
			base_url: 'https://github-worker.secoda.workers.dev/github/initiate/',
		},
		categories: [IntegrationCategory.COMMUNICATION],
		disablePullMetadata: true,
		supportsPreviews: false,
		supportsPushMetadata: true,
		testable: false,
		isBeta: true,
		suggestWhitelist: false,
		supportsChartsTab: true,
		supportsQueryBlocks: false,
		supportsSchemaConfiguration: false,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		secodaEnabled: true,
		isExtension: true,
		secodaCoreEnabled: true,
	},
	{
		name: 'Jira',
		type: 'jira',
		group: 'Productivity',
		description:
			'Sync Jira issues, comments, priority, assigned users and tags, and into Secoda.',
		src: jiraSvg,
		helpArticle: `${DOCS_EXTENSION_BASE}jira`,
		documentationMarkdown: 'https://docs.secoda.com/extensions/jira.md',
		categories: [IntegrationCategory.COMMUNICATION],
		testable: true,
		suggestWhitelist: false,
		secodaEnabled: true,
		isExtension: true,
		supportsPreviews: false,
		supportsQueryBlocks: false,
		supportsSchemaConfiguration: false,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: false,
		supportsChartsTab: true,
		secodaCoreEnabled: true,
	},
	{
		name: 'Metabase',
		type: 'metabase',
		group: 'Data visualization',
		description:
			'Easily search for all your Metabase information in Secoda. The Metabase integration will pull information related to dashboards and put them into their own page on the Secoda UI.',
		src: metabaseSvg,
		helpArticle: `${DOCS_INTEGRATION_BASE}data-visualization-tools/metabase`,
		documentationMarkdown:
			'https://docs.secoda.com/integrations/data-visualization-tools/metabase.md',
		categories: [IntegrationCategory.DASHBOARD],
		entity_type: EntityType.dashboard,
		resource_type: EntityType.dashboard,
		supportsPreviews: true,
		supportsQueryBlocks: false,
		supportsSchemaConfiguration: false,
		supportGoogleIdentityAwareProxy: true,
		supportsPushMetadata: false,
		supportsDataAccessRequests: false,
		testable: true,
		suggestWhitelist: false,
		secodaEnabled: true,
		supportsChartsTab: true,
		secodaCoreEnabled: true,
	},
	{
		name: 'Mixpanel',
		type: 'mixpanel',
		group: 'Data visualization',
		description:
			'Pull in boards, reports, and events from your Mixpanel projects, as well as number of views, owners, descriptions, and lineage. Supplementary documentation can be added to your boards, reports and events to provide even more context to your users.',
		src: mixpanelSvg,
		helpArticle: `${DOCS_INTEGRATION_BASE}data-visualization-tools/mixpanel`,
		documentationMarkdown:
			'https://docs.secoda.com/integrations/data-visualization-tools/mixpanel.md',
		categories: [IntegrationCategory.DASHBOARD],
		entity_type: EntityType.dashboard,
		resource_type: EntityType.dashboard,
		isBeta: false,
		supportsPreviews: true,
		supportsQueryBlocks: false,
		supportsSchemaConfiguration: false,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: false,
		testable: true,
		suggestWhitelist: false,
		supportsChartsTab: true,
		secodaEnabled: true,
		secodaCoreEnabled: true,
	},
	{
		name: 'MongoDB',
		type: 'mongodb',
		group: 'Databases',
		description:
			'Sync MongoDB Clusters, Databases, Collections, and Fields, directly into Secoda.',
		src: mongodbSvg,
		helpArticle: `${DOCS_INTEGRATION_BASE}databases/mongodb`,
		documentationMarkdown:
			'https://docs.secoda.com/integrations/databases/mongodb.md',
		categories: [IntegrationCategory.DATABASE],
		entity_type: EntityType.table,
		resource_type: EntityType.table,
		isBeta: false,
		supportsPreviews: true,
		supportsQueryBlocks: false,
		supportsSchemaConfiguration: true,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: false,
		supportsChartsTab: true,
		testable: true,
		suggestWhitelist: true,
		secodaEnabled: true,
		secodaCoreEnabled: true,
	},
	{
		name: 'Cluvio',
		type: 'cluvio',
		group: 'Data visualization',
		description:
			'Connect Cluvio to Secoda to easily search for all your dashboards information in Secoda.',
		src: cluvioSvg,
		helpArticle: `${DOCS_INTEGRATION_BASE}data-visualization-tools/cluvio`,
		documentationMarkdown:
			'https://docs.secoda.com/integrations/data-visualization-tools/cluvio.md',
		categories: [IntegrationCategory.DASHBOARD],
		entity_type: EntityType.dashboard,
		resource_type: EntityType.dashboard,
		testable: true,
		suggestWhitelist: false,
		supportsPreviews: false,
		supportsQueryBlocks: false,
		supportsSchemaConfiguration: false,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: false,
		supportsChartsTab: true,
		secodaEnabled: true,
		secodaCoreEnabled: true,
	},
	{
		name: 'Lightdash',
		type: 'lightdash',
		group: 'Data visualization',
		description:
			'Lightdash translates the dbt models you already know into optimized SQL required to directly interact with cloud data warehouses.',
		src: lightdashSvg,
		helpArticle: `${DOCS_INTEGRATION_BASE}data-visualization-tools/lightdash`,
		documentationMarkdown:
			'https://docs.secoda.com/integrations/data-visualization-tools/lightdash.md',
		categories: [IntegrationCategory.DASHBOARD],
		entity_type: EntityType.dashboard,
		resource_type: EntityType.dashboard,
		supportsPreviews: true,
		supportsQueryBlocks: false,
		supportsSchemaConfiguration: false,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: false,
		supportsChartsTab: true,
		testable: true,
		suggestWhitelist: false,
		secodaEnabled: true,
		secodaCoreEnabled: true,
	},
	{
		name: 'Sigma',
		type: 'sigma',
		group: 'Data visualization',
		description:
			'Sigma translates the spreadsheet functions and formulas you already know into optimized SQL required to directly interact with cloud data warehouses.',
		src: sigmaSvg,
		srcDark: sigmaDarkSvg,
		helpArticle: `${DOCS_INTEGRATION_BASE}data-visualization-tools/sigma-integration`,
		documentationMarkdown:
			'https://docs.secoda.com/integrations/data-visualization-tools/sigma-integration.md',
		categories: [IntegrationCategory.DASHBOARD],
		entity_type: EntityType.dashboard,
		resource_type: EntityType.dashboard,
		testable: true,
		supportsPreviews: true,
		supportsQueryBlocks: false,
		supportsSchemaConfiguration: false,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: false,
		supportsChartsTab: true,
		suggestWhitelist: false,
		secodaEnabled: true,
		secodaCoreEnabled: true,
	},
	{
		name: 'SQL Server Report Services',
		type: 'ssrs',
		group: 'Data visualization',
		description:
			'Connect SSRS to Secoda to easily search for all your reports information in Secoda.',
		src: sqlserverSvg,
		categories: [IntegrationCategory.DASHBOARD],
		testable: true,
		isBeta: true,
		resource_type: EntityType.dashboard,
		entity_type: EntityType.dashboard,
		helpArticle: `${DOCS_INTEGRATION_BASE}data-visualization-tools/sql-server-reporting-services`,
		documentationMarkdown:
			'https://docs.secoda.com/integrations/data-visualization-tools/sql-server-reporting-services.md',
		suggestWhitelist: true,
		supportsPreviews: false,
		supportsQueryBlocks: false,
		supportsSchemaConfiguration: false,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: false,
		supportsChartsTab: true,
		secodaEnabled: true,
		secodaCoreEnabled: true,
	},
	{
		name: 'Monte Carlo',
		type: 'monte_carlo',
		group: 'Data quality',
		description:
			'Connect Monte Carlo to Secoda to associate monitors with tables in Secoda',
		src: monteCarloSvg,
		helpArticle: `${DOCS_INTEGRATION_BASE}data-quality-tools/monte-carlo`,
		documentationMarkdown:
			'https://docs.secoda.com/integrations/data-quality-tools/monte-carlo.md',
		categories: [IntegrationCategory.TEST],
		account_id: '',
		api_key: '',
		entity_type: EntityType.test,
		resource_type: EntityType.test,
		skipSchemaSelect: true,
		testable: true,
		supportsPreviews: false,
		supportsQueryBlocks: false,
		supportsSchemaConfiguration: false,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: false,
		suggestWhitelist: false,
		secodaEnabled: true,
		supportsChartsTab: true,
		secodaCoreEnabled: true,
	},
	{
		name: 'dbt Cloud',
		type: 'dbt',
		group: 'Data transformation tools',
		description:
			'Connect dbt to Secoda to associate dbt run, dbt data, dbt tests, information with a dataset in Secoda',
		account_id: '',
		api_key: '',
		src: dbtSvg,
		helpArticle: `${DOCS_INTEGRATION_BASE}data-transformation-tools/dbt`,
		documentationMarkdown:
			'https://docs.secoda.com/integrations/data-transformation-tools/readme-1/dbt.md',
		categories: [IntegrationCategory.ORCHESTRATOR],
		entity_type: EntityType.job,
		resource_type: EntityType.job,
		skipSchemaSelect: true,
		testable: true,
		suggestWhitelist: false,
		secodaEnabled: true,
		supportsPreviews: false,
		supportsQueryBlocks: false,
		supportsSchemaConfiguration: false,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: false,
		supportsChartsTab: false,
	},
	{
		name: 'dbt Core',
		type: 'dbt_core',
		group: 'Data transformation tools',
		description:
			'Connect dbt to Secoda to associate dbt run, dbt data, dbt tests, information with a dataset in Secoda',
		src: dbtSvg,
		helpArticle: `${DOCS_INTEGRATION_BASE}data-transformation-tools/dbt/dbt-core`,
		documentationMarkdown:
			'https://docs.secoda.com/integrations/data-transformation-tools/readme-1/dbt-core.md',
		categories: [IntegrationCategory.ORCHESTRATOR],
		entity_type: EntityType.job,
		resource_type: EntityType.job,
		testable: true,
		suggestWhitelist: false,
		secodaEnabled: true,
		supportsPreviews: false,
		supportsQueryBlocks: false,
		supportsSchemaConfiguration: false,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: false,
		supportsChartsTab: false,
	},
	{
		name: 'Coalesce',
		type: 'coalesce',
		group: 'Data transformation tools',
		description:
			'Connect Coalesce to Secoda to associate runs, jobs, and tests in Secoda',
		src: coalesceSvg,
		helpArticle: `${DOCS_INTEGRATION_BASE}data-transformation-tools/coalesce`,
		documentationMarkdown:
			'https://docs.secoda.com/integrations/data-transformation-tools/coalesce.md',
		categories: [IntegrationCategory.ORCHESTRATOR],
		entity_type: EntityType.job,
		resource_type: EntityType.job,
		skipSchemaSelect: true,
		testable: true,
		suggestWhitelist: false,
		supportsPreviews: false,
		supportsQueryBlocks: false,
		supportsSchemaConfiguration: false,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: false,
		supportsChartsTab: true,
		secodaEnabled: true,
		secodaCoreEnabled: true,
	},
	{
		name: 'Matillion ETL',
		type: 'matillion',
		group: 'Data pipeline',
		description:
			'Connect Matillion ETL to Secoda to associate jobs and tasks in Secoda',
		src: matillionSvg,
		helpArticle: `${DOCS_INTEGRATION_BASE}data-pipeline-tools/matillion`,
		documentationMarkdown:
			'https://docs.secoda.com/integrations/data-pipeline-tools/matillion.md',
		categories: [IntegrationCategory.ORCHESTRATOR],
		entity_type: EntityType.job,
		resource_type: EntityType.job,
		skipSchemaSelect: true,
		testable: true,
		suggestWhitelist: false,
		supportsPreviews: false,
		supportsQueryBlocks: false,
		supportsSchemaConfiguration: false,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: false,
		supportsChartsTab: true,
		secodaEnabled: true,
		secodaCoreEnabled: true,
	},
	{
		name: 'Matillion Data Productivity Cloud',
		type: 'matillion_dpc',
		group: 'Data pipeline',
		description:
			'Connect Matillion Data Productivity Cloud to Secoda to extract projects, pipelines, and pipeline runs',
		src: matillionSvg,
		helpArticle: `${DOCS_INTEGRATION_BASE}data-pipeline-tools/matillion`,
		documentationMarkdown:
			'https://docs.secoda.com/integrations/data-pipeline-tools/matillion.md',
		categories: [IntegrationCategory.ORCHESTRATOR],
		entity_type: EntityType.job,
		resource_type: EntityType.job,
		skipSchemaSelect: true,
		testable: true,
		suggestWhitelist: false,
		supportsPreviews: false,
		supportsQueryBlocks: false,
		supportsSchemaConfiguration: false,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: false,
		supportsChartsTab: true,
		secodaEnabled: true,
		secodaCoreEnabled: true,
	},
	{
		name: 'Airflow',
		type: 'airflow',
		group: 'Data pipeline',
		description:
			'Connect Airflow to Secoda to associate DAGS with a dataset in Secoda. The airflow integration will pull information related to Airflow DAGs and put them into their own page on the Secoda UI.',
		src: airflowSvg,
		helpArticle: `${DOCS_INTEGRATION_BASE}data-pipeline-tools/airflow`,
		documentationMarkdown:
			'https://docs.secoda.com/integrations/data-pipeline-tools/airflow.md',
		categories: [IntegrationCategory.ORCHESTRATOR],
		groupSettings: {
			Astronomer: {
				testable: true,
			},
			API: {
				testable: true,
			},
			Plugin: {
				testable: false,
			},
		},
		entity_type: EntityType.job,
		resource_type: EntityType.job,
		suggestWhitelist: true,
		supportsPreviews: false,
		supportsQueryBlocks: false,
		supportsSchemaConfiguration: false,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: false,
		supportsChartsTab: true,
		secodaEnabled: true,
		secodaCoreEnabled: true,
	},
	{
		name: 'Dagster',
		type: 'dagster',
		group: 'Data pipeline',
		description:
			'Connect Dagster to Secoda to easily search for all your Dagster information in Secoda',
		src: dagsterSvg,
		helpArticle: `${DOCS_INTEGRATION_BASE}data-pipeline-tools/dagster`,
		documentationMarkdown:
			'https://docs.secoda.com/integrations/data-pipeline-tools/dagster.md',
		categories: [IntegrationCategory.ORCHESTRATOR],
		entity_type: EntityType.job,
		resource_type: EntityType.job,
		isBeta: true,
		testable: true,
		suggestWhitelist: true,
		supportsPreviews: false,
		supportsQueryBlocks: false,
		supportsSchemaConfiguration: false,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: false,
		supportsChartsTab: true,
		secodaEnabled: true,
		secodaCoreEnabled: true,
	},
	{
		name: 'Druid',
		type: 'druid',
		group: 'Databases',
		description:
			'Connect Druid to Secoda for efficient data discovery, exploration, and understanding how it integrates within your data stack.',
		src: druidSvg,
		helpArticle: `${DOCS_INTEGRATION_BASE}databases/druid`,
		documentationMarkdown:
			'https://docs.secoda.com/integrations/databases/druid.md',
		categories: [IntegrationCategory.DATABASE],
		entity_type: EntityType.table,
		resource_type: EntityType.table,
		supportsPreviews: true,
		supportsQueryBlocks: true,
		supportsSchemaConfiguration: true,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: false,
		supportsChartsTab: true,
		testable: true,
		suggestWhitelist: true,
		secodaEnabled: true,
		secodaCoreEnabled: true,
	},
	{
		name: 'DynamoDB',
		type: 'dynamodb',
		group: 'Databases',
		description:
			'Connect DynamoDB to Secoda to easily search for all your DynamoDB information in Secoda',
		src: dynamodbSvg,
		helpArticle: `${DOCS_INTEGRATION_BASE}databases/dynamodb`,
		documentationMarkdown:
			'https://docs.secoda.com/integrations/databases/dynamodb.md',
		categories: [IntegrationCategory.DATABASE],
		entity_type: EntityType.table,
		resource_type: EntityType.table,
		isBeta: true,
		supportsPreviews: true,
		supportsQueryBlocks: false,
		supportsSchemaConfiguration: true,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: false,
		supportsChartsTab: true,
		testable: true,
		suggestWhitelist: true,
		secodaEnabled: true,
		secodaCoreEnabled: true,
	},
	{
		name: 'Confluence',
		type: 'confluence',
		group: 'Productivity',
		description: 'Sync Confluence Spaces and Pages, directly into Secoda.',
		src: confluenceSvg,
		helpArticle: `${DOCS_EXTENSION_BASE}confluence`,
		documentationMarkdown: 'https://docs.secoda.com/extensions/confluence.md',
		categories: [IntegrationCategory.COMMUNICATION],
		entity_type: EntityType.document,
		resource_type: EntityType.document,
		isBeta: true,
		supportsPreviews: false,
		supportsQueryBlocks: false,
		supportsSchemaConfiguration: true,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: false,
		supportsChartsTab: true,
		testable: true,
		suggestWhitelist: false,
		secodaEnabled: true,
		isExtension: true,
	},
	{
		name: 'Hightouch',
		type: 'hightouch',
		group: 'Data pipeline',
		description:
			'Connect Hightouch to Secoda to document your reverse ETL in the same place as the rest of their data knowledge',
		cookie: '',
		src: hightouchSvg,
		helpArticle: `${DOCS_INTEGRATION_BASE}data-pipeline-tools/hightouch`,
		documentationMarkdown:
			'https://docs.secoda.com/integrations/data-pipeline-tools/hightouch.md',
		categories: [IntegrationCategory.ORCHESTRATOR],
		entity_type: EntityType.job,
		resource_type: EntityType.job,
		testable: true,
		suggestWhitelist: false,
		supportsPreviews: false,
		supportsQueryBlocks: false,
		supportsSchemaConfiguration: false,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: false,
		supportsChartsTab: true,
		secodaEnabled: true,
		secodaCoreEnabled: true,
	},
	{
		name: 'Census',
		type: 'census',
		group: 'Data pipeline',
		description:
			'Connect Census to Secoda to document your reverse ETL in the same place as the rest of their data knowledge',
		src: censusSvg,
		helpArticle: `${DOCS_INTEGRATION_BASE}data-pipeline-tools/census`,
		documentationMarkdown:
			'https://docs.secoda.com/integrations/data-pipeline-tools/census.md',
		categories: [IntegrationCategory.ORCHESTRATOR],
		entity_type: EntityType.job,
		resource_type: EntityType.job,
		testable: true,
		suggestWhitelist: false,
		supportsPreviews: false,
		supportsQueryBlocks: false,
		supportsSchemaConfiguration: false,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: false,
		supportsChartsTab: true,
		secodaEnabled: true,
		secodaCoreEnabled: true,
	},
	{
		name: 'Polytomic',
		type: 'polytomic',
		group: 'Data pipeline',
		description: 'Connect Polytomic to Secoda to document your data pipelines',
		src: polytomicSvg,
		helpArticle: `${DOCS_INTEGRATION_BASE}data-pipeline-tools/polytomic`,
		documentationMarkdown:
			'https://docs.secoda.com/integrations/data-pipeline-tools/polytomic.md',
		categories: [IntegrationCategory.ORCHESTRATOR],
		entity_type: EntityType.job,
		resource_type: EntityType.job,
		testable: true,
		suggestWhitelist: false,
		supportsPreviews: false,
		supportsQueryBlocks: false,
		supportsSchemaConfiguration: false,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: false,
		supportsChartsTab: true,
		secodaEnabled: true,
		secodaCoreEnabled: true,
	},
	{
		name: 'Fivetran',
		type: 'fivetran',
		group: 'Data pipeline',
		description:
			'Connect Fivetran to Secoda to easily search for all your ETL information in Secoda.',
		src: fivetranSvg,
		helpArticle: `${DOCS_INTEGRATION_BASE}data-pipeline-tools/fivetran-integration`,
		documentationMarkdown:
			'https://docs.secoda.com/integrations/data-pipeline-tools/fivetran-integration.md',
		categories: [IntegrationCategory.ORCHESTRATOR],
		entity_type: EntityType.job,
		resource_type: EntityType.job,
		testable: true,
		suggestWhitelist: false,
		supportsPreviews: false,
		supportsQueryBlocks: false,
		supportsSchemaConfiguration: true,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: false,
		supportsChartsTab: true,
		secodaEnabled: true,
		secodaCoreEnabled: true,
	},
	{
		name: 'Stitch',
		type: 'stitch',
		group: 'Data pipeline',
		description:
			'Connect Stitch to Secoda to easily search for all your ETL information in Secoda.',
		src: stitchSvg,
		helpArticle: `${DOCS_INTEGRATION_BASE}data-pipeline-tools/stitch`,
		documentationMarkdown:
			'https://docs.secoda.com/integrations/data-pipeline-tools/stitch.md',
		categories: [IntegrationCategory.ORCHESTRATOR],
		entity_type: EntityType.job,
		resource_type: EntityType.job,
		isBeta: false,
		testable: true,
		suggestWhitelist: false,
		supportsPreviews: false,
		supportsQueryBlocks: false,
		supportsSchemaConfiguration: false,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: false,
		supportsChartsTab: true,
		secodaEnabled: true,
		secodaCoreEnabled: true,
	},
	{
		name: 'Amplitude',
		type: 'amplitude',
		group: 'Data visualization',
		description:
			'The Amplitude integration will pull information related to events, governance, put them into their own page on the Secoda UI.',
		src: amplitudeSvg,
		helpArticle: `${DOCS_INTEGRATION_BASE}data-visualization-tools/amplitude-integration`,
		documentationMarkdown:
			'https://docs.secoda.com/integrations/data-visualization-tools/amplitude-integration.md',
		categories: [IntegrationCategory.ORCHESTRATOR],
		entity_type: EntityType.event,
		resource_type: EntityType.event,
		testable: true,
		suggestWhitelist: false,
		supportsPreviews: false,
		supportsQueryBlocks: false,
		supportsSchemaConfiguration: false,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: false,
		supportsChartsTab: true,
		secodaEnabled: true,
		secodaCoreEnabled: true,
	},
	{
		name: 'Git',
		type: 'git',
		group: 'Productivity',
		description: 'Connect Git to Secoda to document your data pipelines',
		src: gitSvg,
		helpArticle: '',
		documentationMarkdown: '',
		categories: [IntegrationCategory.ORCHESTRATOR],
		entity_type: EntityType.event,
		resource_type: EntityType.event,
		testable: true,
		suggestWhitelist: false,
		supportsPreviews: false,
		supportsQueryBlocks: false,
		supportsSchemaConfiguration: false,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: false,
		supportsChartsTab: true,
		secodaEnabled: true,
		isExtension: true,
		secodaCoreEnabled: true,
		featureFlag: 'legacy-git-integration',
	},
	{
		name: 'Code Repo',
		type: 'ai_git',
		group: 'Productivity',
		description:
			'Give Secoda AI access to your codebase for additional context.',
		src: gitSvg,
		helpArticle: '',
		documentationMarkdown: '',
		categories: [IntegrationCategory.COMMUNICATION],
		entity_type: EntityType.document,
		resource_type: EntityType.document,
		testable: true,
		suggestWhitelist: false,
		supportsPreviews: false,
		supportsQueryBlocks: false,
		supportsSchemaConfiguration: false,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: false,
		supportsChartsTab: false,
		secodaEnabled: true,
		isExtension: false,
		disablePullMetadata: true,
		featureFlag: 'gitAgent',
	},
	{
		name: 'Looker Studio',
		type: 'looker_studio',
		group: 'Data visualization',
		description:
			'Connect Looker Studio to find your queries, dashboards and visualizations easily. Use Secoda to understand how Looker Studio connects to the rest of your data stack.',
		src: lookerStudioSvg,
		helpArticle: `${DOCS_INTEGRATION_BASE}data-visualization-tools/google-data-studio`,
		documentationMarkdown:
			'https://docs.secoda.com/integrations/data-visualization-tools/google-data-studio.md',
		categories: [IntegrationCategory.DASHBOARD],
		groupSettings: {
			OAuth: {
				isOAuth: true,
				testable: false,
			},
			Cookie: {
				testable: true,
			},
		},
		entity_type: EntityType.dashboard,
		resource_type: EntityType.dashboard,
		supportsPreviews: true,
		supportsQueryBlocks: false,
		supportsSchemaConfiguration: false,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: false,
		supportsChartsTab: true,
		suggestWhitelist: false,
		secodaEnabled: true,
		secodaCoreEnabled: true,
	},
	{
		name: 'Great Expectations',
		type: 'great_expectations',
		group: 'Data quality',
		description:
			'Get all your data testing, documentation, and profiling in Secoda.',
		src: greatExpectationsSvg,
		helpArticle: `${DOCS_INTEGRATION_BASE}data-quality-tools/great-expectations-integration`,
		documentationMarkdown:
			'https://docs.secoda.com/integrations/data-quality-tools/great-expectations-integration.md',
		categories: [IntegrationCategory.TEST],
		entity_type: EntityType.test,
		resource_type: EntityType.test,
		testable: true,
		suggestWhitelist: false,
		supportsPreviews: false,
		supportsQueryBlocks: false,
		supportsSchemaConfiguration: false,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: false,
		supportsChartsTab: true,
		secodaEnabled: true,
		secodaCoreEnabled: true,
	},
	{
		name: 'GX Core',
		type: 'gx_core',
		group: 'Data quality',
		description:
			'Get all your data testing, documentation, and profiling in Secoda.',
		src: greatExpectationsSvg,
		helpArticle: `${DOCS_INTEGRATION_BASE}data-quality-tools/great-expectations-integration`,
		documentationMarkdown:
			'https://docs.secoda.com/integrations/data-quality-tools/great-expectations-integration.md',
		categories: [IntegrationCategory.TEST],
		entity_type: EntityType.test,
		resource_type: EntityType.test,
		testable: true,
		suggestWhitelist: false,
		supportsPreviews: false,
		supportsQueryBlocks: false,
		supportsSchemaConfiguration: false,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: false,
		supportsChartsTab: true,
		secodaEnabled: true,
		secodaCoreEnabled: true,
	},
	{
		name: 'Salesforce',
		type: 'salesforce',
		group: 'Databases',
		description:
			'Save yourself countless hours troubleshooting data in your Salesforce environment. See all field references in your entire organization and go to market faster than ever.',
		src: salesforceSvg,
		helpArticle: `${DOCS_INTEGRATION_BASE}databases/salesforce-integration`,
		documentationMarkdown:
			'https://docs.secoda.com/integrations/databases/salesforce-integration.md',
		groupSettings: {
			OAuth: {
				isOAuth: true,
				testable: false,
			},
			Password: {
				testable: true,
			},
		},
		categories: [IntegrationCategory.DATABASE],
		entity_type: EntityType.table,
		resource_type: EntityType.table,
		isBeta: false,
		supportsPreviews: true,
		supportsQueryBlocks: true,
		supportsSchemaConfiguration: false,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: false,
		supportsChartsTab: true,
		suggestWhitelist: false,
		secodaEnabled: true,
		secodaCoreEnabled: true,
		isExtension: false,
	},
	{
		name: 'Retool',
		type: 'retool',
		group: 'Data visualization',
		description:
			'Secoda and Retool have teamed up to offer users a powerful platform for developers to build custom web apps. Easily access various data sources and APIs to develop applications that are personalized to their needs.',
		src: retoolSvg,
		helpArticle: `${DOCS_INTEGRATION_BASE}data-visualization-tools/retool-integration`,
		documentationMarkdown:
			'https://docs.secoda.com/integrations/data-visualization-tools/retool-integration.md',
		categories: [IntegrationCategory.DASHBOARD],
		entity_type: EntityType.dashboard,
		resource_type: EntityType.dashboard,
		isBeta: false,
		supportsPreviews: true,
		supportsQueryBlocks: false,
		supportsSchemaConfiguration: false,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: false,
		supportsChartsTab: true,
		testable: true,
		suggestWhitelist: false,
		secodaEnabled: true,
		secodaCoreEnabled: true,
	},
	{
		name: 'Azure Synapse',
		type: 'synapse',
		group: 'Data warehouses',
		description:
			'Sync Azure Synapse Tables, Views, Columns, Creation Query, Lineage, and more directly into Secoda.',
		supportsPreviews: true,
		src: synapseSvg,
		helpArticle: `${DOCS_INTEGRATION_BASE}data-warehouses/azure-synapse`,
		documentationMarkdown:
			'https://docs.secoda.com/integrations/data-warehouses/azure-synapse.md',
		categories: [IntegrationCategory.DATABASE],
		entity_type: EntityType.table,
		resource_type: EntityType.table,
		isBeta: true,
		supportsQueryBlocks: true,
		supportsSchemaConfiguration: true,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: false,
		supportsChartsTab: true,
		testable: true,
		suggestWhitelist: true,
		secodaEnabled: true,
		secodaCoreEnabled: true,
	},
	{
		name: 'Azure Cosmos DB',
		type: 'cosmos',
		group: 'Databases',
		description:
			'Sync Azure Cosmos DB databases and containers directly into Secoda.',
		supportsPreviews: false,
		src: cosmosSvg,
		helpArticle: `${DOCS_INTEGRATION_BASE}databases/azure-cosmos-db`,
		documentationMarkdown:
			'https://docs.secoda.com/integrations/databases/azure-cosmos-db.md',
		categories: [IntegrationCategory.DATABASE],
		entity_type: EntityType.table,
		resource_type: EntityType.table,
		isBeta: true,
		supportsQueryBlocks: false,
		supportsSchemaConfiguration: true,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: false,
		supportsChartsTab: true,
		testable: true,
		suggestWhitelist: true,
		secodaEnabled: true,
		secodaCoreEnabled: true,
	},
	{
		name: 'ThoughtSpot',
		type: 'thoughtspot',
		group: 'Data visualization',
		description:
			'Connect ThoughtSpot to Secoda to easily search for all your analytics in Secoda.',
		src: thoughtspotSvg,
		categories: [IntegrationCategory.DASHBOARD],
		helpArticle: `${DOCS_INTEGRATION_BASE}data-visualization-tools/thoughtspot`,
		documentationMarkdown:
			'https://docs.secoda.com/integrations/data-visualization-tools/thoughtspot.md',
		entity_type: EntityType.dashboard,
		resource_type: EntityType.dashboard,
		isBeta: true,
		supportsPreviews: true,
		supportsQueryBlocks: false,
		supportsSchemaConfiguration: false,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: false,
		supportsChartsTab: true,
		testable: true,
		suggestWhitelist: false,
		secodaEnabled: true,
		secodaCoreEnabled: true,
	},
	{
		name: 'Superset',
		type: 'superset',
		group: 'Data visualization',
		description:
			'Connect Superset to Secoda to easily search for all your analytics in Secoda.',
		src: supersetSvg,
		helpArticle: `${DOCS_INTEGRATION_BASE}data-visualization-tools/superset`,
		documentationMarkdown:
			'https://docs.secoda.com/integrations/data-visualization-tools/superset.md',
		categories: [IntegrationCategory.DASHBOARD],
		entity_type: EntityType.dashboard,
		resource_type: EntityType.dashboard,
		isBeta: true,
		supportsPreviews: true,
		supportsQueryBlocks: false,
		supportsSchemaConfiguration: false,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: false,
		supportsChartsTab: true,
		testable: true,
		suggestWhitelist: false,
		secodaEnabled: true,
		secodaCoreEnabled: true,
	},
	{
		name: 'Preset',
		type: 'preset',
		group: 'Data visualization',
		description:
			'Connect Preset to Secoda to easily search for all your analytics in Secoda.',
		src: presetSvg,
		helpArticle: `${DOCS_INTEGRATION_BASE}data-visualization-tools/preset`,
		documentationMarkdown:
			'https://docs.secoda.com/integrations/data-visualization-tools/preset.md',
		categories: [IntegrationCategory.DASHBOARD],
		resource_type: EntityType.dashboard,
		entity_type: EntityType.dashboard,
		isBeta: true,
		supportsPreviews: false,
		supportsQueryBlocks: false,
		supportsSchemaConfiguration: false,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: false,
		supportsChartsTab: true,
		testable: true,
		suggestWhitelist: false,
		secodaEnabled: true,
		secodaCoreEnabled: true,
	},
	{
		name: 'SingleStore',
		type: 'singlestore',
		group: 'Databases',
		description: 'Sync SingleStore databases and tables directly into Secoda',
		src: singlestoreSvg,
		helpArticle: `${DOCS_INTEGRATION_BASE}databases/singlestore`,
		documentationMarkdown:
			'https://docs.secoda.com/integrations/databases/singlestore.md',
		categories: [IntegrationCategory.DATABASE],
		resource_type: EntityType.table,
		entity_type: EntityType.table,
		isBeta: false,
		supportsPreviews: true,
		supportsQueryBlocks: true,
		supportsSchemaConfiguration: true,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: false,
		supportsChartsTab: true,
		testable: true,
		suggestWhitelist: true,
		secodaEnabled: true,
		secodaCoreEnabled: true,
	},
	{
		name: 'Cyera',
		type: 'cyera',
		group: 'Data quality',
		description: 'Connect Cyera to Secoda to tag all your sensitive data',
		src: cyeraSvg,
		helpArticle: `${DOCS_INTEGRATION_BASE}data-quality-tools/cyera`,
		documentationMarkdown:
			'https://docs.secoda.com/integrations/data-quality-tools/cyera.md',
		categories: [IntegrationCategory.TEST],
		isBeta: true,
		supportsPreviews: false,
		supportsQueryBlocks: false,
		supportsSchemaConfiguration: false,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: false,
		supportsChartsTab: true,
		skipSchemaSelect: true,
		testable: true,
		suggestWhitelist: false,
		secodaEnabled: true,
		secodaCoreEnabled: true,
	},
	{
		name: 'Hashboard',
		type: 'hashboard',
		group: 'Data visualization',
		description:
			'Connect Hashboard to view all metrics, dashboards, models, and saved exploration in Secoda',
		src: hashboardSvg,
		helpArticle: `${DOCS_INTEGRATION_BASE}data-visualization-tools/hashboard`,
		documentationMarkdown:
			'https://docs.secoda.com/integrations/data-visualization-tools/hashboard.md',
		categories: [IntegrationCategory.DASHBOARD],
		entity_type: EntityType.dashboard,
		resource_type: EntityType.dashboard,
		isBeta: true,
		supportsPreviews: true,
		supportsQueryBlocks: false,
		supportsSchemaConfiguration: false,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: false,
		supportsChartsTab: true,
		testable: true,
		suggestWhitelist: false,
		secodaEnabled: true,
		secodaCoreEnabled: true,
	},
	{
		name: 'Apache Kafka',
		type: 'kafka',
		group: 'Data pipeline',
		description:
			'Connect Apache Kafka to Secoda. The kafka integration will pull information related to Kafka Topics and Consumer Groups into Secoda.',
		src: kafkaSvg,
		helpArticle: `${DOCS_INTEGRATION_BASE}data-pipeline-tools/apache-kafka`,
		documentationMarkdown:
			'https://docs.secoda.com/integrations/data-pipeline-tools/apache-kafka.md',
		categories: [IntegrationCategory.ORCHESTRATOR],
		testable: true,
		supportsPreviews: false,
		supportsQueryBlocks: false,
		supportsSchemaConfiguration: false,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: false,
		supportsChartsTab: true,
		isBeta: true,
		resource_type: EntityType.job,
		entity_type: EntityType.job,
		suggestWhitelist: false,
		secodaEnabled: true,
		secodaCoreEnabled: true,
	},
	{
		name: 'Confluent Cloud',
		type: 'confluent_cloud',
		group: 'Data pipeline',
		description:
			'Connect Confluent Cloud to Secoda. The kafka integration will pull information related to Kafka Topics and Consumer Groups into Secoda.',
		src: confluentKafkaSvg,
		helpArticle: `${DOCS_INTEGRATION_BASE}data-pipeline-tools/confluent-cloud`,
		documentationMarkdown:
			'https://docs.secoda.com/integrations/data-pipeline-tools/confluent-cloud.md',
		categories: [IntegrationCategory.ORCHESTRATOR],
		testable: true,
		supportsPreviews: false,
		supportsQueryBlocks: false,
		supportsSchemaConfiguration: false,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: false,
		supportsChartsTab: true,
		isBeta: true,
		resource_type: EntityType.job,
		entity_type: EntityType.job,
		suggestWhitelist: false,
		secodaEnabled: true,
		secodaCoreEnabled: true,
	},
	{
		name: 'PagerDuty',
		type: 'pagerduty',
		group: 'Productivity',
		description: 'Connect PagerDuty to Secoda to receive Monitoring Alerts',
		account_id: '',
		api_key: '',
		src: pagerdutySvg,
		helpArticle: `${DOCS_EXTENSION_BASE}pager-duty`,
		categories: [IntegrationCategory.TEST],
		testable: false,
		supportsSchemaConfiguration: false,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: false,
		supportsPreviews: false,
		supportsQueryBlocks: false,
		supportsChartsTab: true,
		skipSchemaSelect: true,
		documentationMarkdown: 'https://docs.secoda.com/extensions/pager-duty.md',
		suggestWhitelist: false,
		secodaEnabled: true,
		isExtension: true,
		secodaCoreEnabled: true,
	},
	{
		name: 'Google Cloud Storage',
		type: 'gcs',
		group: 'Data storage',
		description: 'Connect Google Cloud Storage buckets to Secoda',
		src: gcsSvg,
		categories: [IntegrationCategory.STORAGE],
		testable: true,
		supportsPreviews: false,
		supportsQueryBlocks: false,
		supportsSchemaConfiguration: false,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: false,
		supportsChartsTab: true,
		isBeta: true,
		resource_type: EntityType.table,
		entity_type: EntityType.table,
		helpArticle: `${DOCS_INTEGRATION_BASE}data-lakes/google-cloud-storage`,
		documentationMarkdown:
			'https://docs.secoda.com/integrations/data-lakes/google-cloud-storage.md',
		suggestWhitelist: false,
		secodaEnabled: true,
		secodaCoreEnabled: true,
	},
	{
		name: 'S3',
		type: 's3',
		group: 'Data storage',
		description: 'Connect S3 buckets to Secoda',
		src: s3Svg,
		categories: [IntegrationCategory.STORAGE],
		testable: true,
		supportsPreviews: false,
		supportsQueryBlocks: false,
		supportsSchemaConfiguration: false,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: false,
		supportsChartsTab: true,
		isBeta: true,
		resource_type: EntityType.table,
		entity_type: EntityType.table,
		helpArticle: `${DOCS_INTEGRATION_BASE}data-lakes/aws-s3`,
		documentationMarkdown:
			'https://docs.secoda.com/integrations/data-lakes/aws-s3.md',
		suggestWhitelist: false,
		secodaEnabled: true,
		secodaCoreEnabled: true,
	},
	{
		name: 'Hex',
		type: 'hex',
		group: 'Data visualization',
		description: 'Connect Hex to Secoda to view Hex projects',
		src: hexSvg,
		helpArticle: `${DOCS_INTEGRATION_BASE}data-visualization-tools/hex`,
		documentationMarkdown:
			'https://docs.secoda.com/integrations/data-visualization-tools/hex.md',
		categories: [IntegrationCategory.DASHBOARD],
		entity_type: EntityType.dashboard,
		isBeta: true,
		resource_type: EntityType.dashboard,
		supportsPreviews: true,
		supportsQueryBlocks: false,
		supportsSchemaConfiguration: false,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: false,
		supportsChartsTab: false,
		testable: true,
		suggestWhitelist: false,
		secodaEnabled: true,
		secodaCoreEnabled: true,
	},
	{
		name: 'File Upload',
		type: 'custom',
		group: 'Custom',
		description:
			'Connect any data source to Secoda using CSV or JSONL to easily search for all your information in Secoda.',
		src: customSvg,
		helpArticle: `${DOCS_INTEGRATION_BASE}custom-integrations-and-marketplace/custom-integration`,
		documentationMarkdown:
			'https://docs.secoda.com/integrations/custom-integrations-and-marketplace/custom-integration.md',
		categories: [IntegrationCategory.CUSTOM],
		entity_type: EntityType.table,
		hidden: false,
		suggestWhitelist: false,
		supportsPreviews: false,
		supportsQueryBlocks: false,
		supportsSchemaConfiguration: false,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: false,
		supportsChartsTab: true,
		secodaEnabled: true,
		secodaCoreEnabled: true,
	},
	{
		name: 'Marketplace',
		type: 'marketplace',
		group: 'Custom',
		description: 'Write your own integration for the Secoda Marketplace.',
		src: customSvg,
		helpArticle: `${DOCS_INTEGRATION_BASE}custom-integrations-and-marketplace/secoda-sdk-custom-integration`,
		documentationMarkdown:
			'https://docs.secoda.com/integrations/custom-integrations-and-marketplace/secoda-sdk-custom-integration.md',
		categories: [IntegrationCategory.CUSTOM],
		entity_type: EntityType.table,
		hidden: true,
		suggestWhitelist: false,
		supportsPreviews: false,
		supportsQueryBlocks: false,
		supportsSchemaConfiguration: false,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: false,
		supportsChartsTab: true,
		secodaEnabled: true,
		secodaCoreEnabled: true,
	},
	{
		name: 'Airbyte',
		type: 'airbyte',
		group: 'Data pipeline',
		categories: [IntegrationCategory.ORCHESTRATOR],
		description:
			'Connect Airbyte to Secoda to track your ETL pipelines in the same place as the rest of your data knowledge',
		src: airbyteSvg,
		helpArticle: `${DOCS_INTEGRATION_BASE}data-pipeline-tools/airbyte`,
		documentationMarkdown:
			'https://docs.secoda.com/integrations/data-pipeline-tools/airbyte.md',
		testable: true,
		entity_type: EntityType.job,
		resource_type: EntityType.job,
		supportsPreviews: false,
		supportsQueryBlocks: false,
		supportsSchemaConfiguration: false,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: false,
		supportsChartsTab: true,
		suggestWhitelist: false,
		secodaEnabled: true,
		secodaCoreEnabled: true,
	},
	{
		name: 'Informatica',
		type: 'informatica',
		group: 'Data pipeline',
		description:
			'Connect Informatica to Secoda to associate jobs and tasks in Secoda',
		src: informaticaSvg,
		helpArticle: `${DOCS_INTEGRATION_BASE}data-pipeline-tools/informatica`,
		documentationMarkdown:
			'https://docs.secoda.com/integrations/data-pipeline-tools/informatica.md',
		categories: [IntegrationCategory.ORCHESTRATOR],
		entity_type: EntityType.job,
		resource_type: EntityType.job,
		skipSchemaSelect: true,
		testable: true,
		suggestWhitelist: false,
		supportsPreviews: false,
		supportsQueryBlocks: false,
		supportsSchemaConfiguration: false,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: false,
		supportsChartsTab: true,
		secodaEnabled: true,
		secodaCoreEnabled: true,
	},
	{
		name: 'Azure Data Factory',
		type: 'datafactory',
		group: 'Data pipeline',
		categories: [IntegrationCategory.ORCHESTRATOR],
		description:
			'Connect Azure Data Factory to Secoda to track your ETL pipelines in the same place as the rest of your data knowledge',
		src: datafactorySvg,
		helpArticle: `${DOCS_INTEGRATION_BASE}data-pipeline-tools/azure-data-factory`,
		documentationMarkdown:
			'https://docs.secoda.com/integrations/data-pipeline-tools/azure-data-factory.md',
		testable: true,
		entity_type: EntityType.job,
		resource_type: EntityType.job,
		groupSettings: {
			OAuth: {
				isOAuth: true,
				testable: false,
			},
			Managed: {
				testable: true,
			},
		},
		suggestWhitelist: false,
		supportsPreviews: false,
		supportsQueryBlocks: false,
		supportsSchemaConfiguration: false,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: false,
		supportsChartsTab: true,
		secodaEnabled: true,
		secodaCoreEnabled: true,
	},
	{
		name: 'Gmail',
		type: 'gmail',
		group: 'Productivity',
		description:
			'Connect your Gmail account to Secoda to search and discover emails, track communication history, and manage email documentation.',
		src: gmailSvg,
		helpArticle: `${DOCS_EXTENSION_BASE}gmail`,
		documentationMarkdown: 'https://docs.secoda.com/extensions/gmail.md',
		categories: [IntegrationCategory.COMMUNICATION],
		entity_type: EntityType.document,
		resource_type: EntityType.document,
		supportsPreviews: true,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: false,
		supportsQueryBlocks: false,
		groupSettings: {
			OAuth: {
				isOAuth: true,
				testable: true,
			},
		},
		testable: true,
		supportsSchemaConfiguration: true,
		supportsChartsTab: true,
		suggestWhitelist: false,
		secodaEnabled: false,
	},
	{
		name: 'Linear',
		type: 'linear',
		group: 'Productivity',
		description:
			'Connect your Linear workspace to Secoda to search and discover issues, track project progress, and manage task documentation.',
		src: linearSvg,
		helpArticle: `${DOCS_EXTENSION_BASE}linear`,
		documentationMarkdown: 'https://docs.secoda.com/extensions/linear.md',
		categories: [IntegrationCategory.COMMUNICATION],
		entity_type: EntityType.document,
		resource_type: EntityType.document,
		supportsPreviews: true,
		supportsQueryBlocks: false,
		groupSettings: {
			OAuth: {
				isOAuth: true,
				testable: true,
			},
		},
		testable: true,
		supportsSchemaConfiguration: true,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: false,
		supportsChartsTab: true,
		suggestWhitelist: false,
		secodaEnabled: false,
		isExtension: true,
	},
	{
		name: 'ClickHouse',
		type: 'clickhouse',
		group: 'Databases',
		description:
			'Connect ClickHouse to Secoda to find your queries and tables easily. You can use Secoda to understand how ClickHouse connects to the rest of your data stack.',
		src: clickhouseSvg,
		helpArticle: `${DOCS_INTEGRATION_BASE}data-warehouses/clickhouse`,
		documentationMarkdown:
			'https://docs.secoda.com/integrations/data-warehouses/clickhouse.md',
		categories: [IntegrationCategory.DATABASE],
		entity_type: EntityType.table,
		resource_type: EntityType.table,
		supportsPreviews: true,
		supportsQueryBlocks: true,
		supportsChartsTab: true,
		supportsSchemaConfiguration: true,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: true,
		testable: true,
		suggestWhitelist: true,
		secodaEnabled: true,
		secodaCoreEnabled: true,
	},
	{
		name: 'Snowflake Native App',
		type: 'native_snowflake',
		group: 'Data warehouses',
		description: 'Connect Snowflake Native App to Secoda',
		src: snowflakeSvg,
		categories: [IntegrationCategory.DATABASE],
		testable: false,
		supportsPreviews: false,
		supportsSchemaConfiguration: false,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: false,
		supportsChartsTab: true,
		supportsQueryBlocks: false,
		isBeta: true,
		resource_type: EntityType.table,
		entity_type: EntityType.table,
		helpArticle: `${DOCS_INTEGRATION_BASE}data-warehouses/snowflake-integration`,
		documentationMarkdown:
			'https://docs.secoda.com/integrations/data-warehouses/snowflake-integration/native-snowflake.md',
		suggestWhitelist: false,
		secodaEnabled: true,
		secodaCoreEnabled: true,
	},
	{
		name: 'Soda Cloud',
		type: 'soda',
		group: 'Data quality',
		description: 'Connect Soda Cloud to Secoda',
		src: sodaSvg,
		categories: [IntegrationCategory.TEST],
		testable: false,
		supportsPreviews: false,
		supportsChartsTab: true,
		supportsQueryBlocks: false,
		supportsSchemaConfiguration: false,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: false,
		isBeta: true,
		resource_type: EntityType.test,
		entity_type: EntityType.test,
		helpArticle: `${DOCS_INTEGRATION_BASE}data-quality-tools/soda`,
		documentationMarkdown:
			'https://docs.secoda.com/integrations/data-quality-tools/soda.md',
		suggestWhitelist: false,
		secodaEnabled: true,
		secodaCoreEnabled: true,
	},
	{
		name: 'Dataform',
		type: 'dataform',
		group: 'Data transformation tools',
		description:
			'Connect Dataform to Secoda to find your tables, workflows, and metadata easily. You can use Secoda to understand how Dataform tables and workflows connect to the rest of your data stack.',
		src: dataformSvg,
		helpArticle: `${DOCS_INTEGRATION_BASE}data-transformation-tools/dataform`,
		documentationMarkdown:
			'https://docs.secoda.com/integrations/data-transformation-tools/dataform.md',
		categories: [IntegrationCategory.ORCHESTRATOR],
		entity_type: EntityType.job,
		resource_type: EntityType.job,
		skipSchemaSelect: true,
		testable: true,
		suggestWhitelist: false,
		secodaEnabled: true,
		secodaCoreEnabled: true,
		supportsPreviews: false,
		supportsQueryBlocks: false,
		supportsSchemaConfiguration: false,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: false,
		supportsChartsTab: false,
		isBeta: true,
		groupSettings: {
			OAuth: {
				isOAuth: true,
				testable: false,
			},
			Credentials: {
				testable: true,
			},
		},
	},
	{
		name: 'Azure Data Lake',
		type: 'datalake',
		group: 'Data storage',
		categories: [IntegrationCategory.STORAGE],
		description:
			'Connect Azure Data Lake Storage to Secoda to track your data lake files and directories in Secoda.',
		src: datalakeSvg,
		helpArticle: `${DOCS_INTEGRATION_BASE}data-lakes/azure-data-lake`,
		documentationMarkdown:
			'https://docs.secoda.com/integrations/data-lakes/azure-data-lake.md',
		testable: true,
		entity_type: EntityType.table,
		resource_type: EntityType.table,
		supportsPreviews: false,
		supportsQueryBlocks: false,
		supportsSchemaConfiguration: true,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: false,
		supportsChartsTab: true,
		isBeta: true,
		groupSettings: {
			OAuth: {
				isOAuth: true,
				testable: false,
			},
			Managed: {
				testable: true,
			},
			Fabric: {
				isOAuth: true,
				testable: true,
			},
		},
		suggestWhitelist: false,
		secodaEnabled: true,
		secodaCoreEnabled: true,
	},
	{
		name: 'Glean',
		type: 'glean',
		group: 'Productivity',
		description: 'Connect Glean to Secoda',
		src: gleanSvg,
		categories: [IntegrationCategory.COMMUNICATION],
		testable: false,
		disablePullMetadata: true,
		supportsPreviews: false,
		supportsChartsTab: true,
		supportsQueryBlocks: false,
		supportsSchemaConfiguration: false,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: true,
		isBeta: true,
		resource_type: EntityType.all,
		entity_type: EntityType.all,
		helpArticle: `${DOCS_EXTENSION_BASE}glean`,
		documentationMarkdown: 'https://docs.secoda.com/extensions/glean.md',
		suggestWhitelist: false,
		secodaEnabled: true,
		isExtension: true,
		secodaCoreEnabled: true,
	},
	{
		name: 'ServiceNow',
		type: 'servicenow',
		group: 'Productivity',
		description:
			'Connect your ServiceNow instance to Secoda to synchronize data access requests with ServiceNow forms. This integration enables bi-directional sync of request statuses.',
		src: servicenowSvg,
		helpArticle: `${DOCS_EXTENSION_BASE}servicenow`,
		documentationMarkdown: 'https://docs.secoda.com/extensions/servicenow.md',
		categories: [IntegrationCategory.COMMUNICATION],
		disablePullMetadata: true,
		supportsPushMetadata: false,
		secodaEnabled: true,
		testable: false,
		supportsDataAccessRequests: false,
		supportsDataAccessRequestPreferences: ['manual'],
		supportsPreviews: false,
		supportsQueryBlocks: false,
		supportsSchemaConfiguration: false,
		supportGoogleIdentityAwareProxy: false,
		supportsChartsTab: true,
		isExtension: true,
		isBeta: true,
		secodaCoreEnabled: true,
	},
	{
		name: 'MicroStrategy',
		type: 'microstrategy',
		group: 'Custom',
		description:
			'Connect MicroStrategy to Secoda to discover your reports, dossiers, and datasets. Organize your MicroStrategy content by project with dedicated folders for different content types.',
		src: microStrategySvg,
		helpArticle: `${DOCS_INTEGRATION_BASE}data-visualization-tools/microstrategy-one`,
		documentationMarkdown:
			'https://docs.secoda.com/integrations/data-visualization-tools/microstrategy-one.md',
		categories: [IntegrationCategory.CUSTOM],
		entity_type: EntityType.dashboard,
		resource_type: EntityType.dashboard,
		supportsPreviews: false,
		supportsQueryBlocks: false,
		supportsSchemaConfiguration: true,
		supportsPushMetadata: false,
		supportsChartsTab: false,
		testable: true,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		suggestWhitelist: false,
		secodaEnabled: true,
		supportsUserLevelCredentials: false,
		// For future dev making feature flag for integration, the name should be in camelCase in this field
		featureFlag: 'microStrategyOneIntegration',
		groupSettings: {
			OIDC: {
				isOidc: true,
				testable: true,
			},
			Standard: {
				testable: true,
			},
		},
	},
	{
		name: 'Starburst',
		type: 'starburst',
		group: 'Databases',
		description:
			'Connect Starburst to Secoda to find your queries and tables easily. You can use Secoda to understand how Starburst connects to the rest of your data stack.',
		src: starburstSvg,
		categories: [IntegrationCategory.DATABASE],
		helpArticle: `${DOCS_INTEGRATION_BASE}query-engines/starburst`,
		documentationMarkdown:
			'https://docs.secoda.com/integrations/query-engines/starburst.md',
		testable: true,
		entity_type: EntityType.table,
		resource_type: EntityType.table,
		supportsPreviews: true,
		supportsQueryBlocks: true,
		supportsSchemaConfiguration: true,
		supportsDataAccessRequests: false,
		supportGoogleIdentityAwareProxy: false,
		supportsPushMetadata: false,
		supportsChartsTab: true,
		suggestWhitelist: true,
		secodaEnabled: true,
		secodaCoreEnabled: true,
	},
];
